export const useOrderFilter = {
  data() {
    return {
      order: 'desc',
    };
  },
  methods: {
    toggleOrder() {
      const nextState = this.order === 'desc' ? 'asc' : 'desc';
      this.order = nextState;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/useOrderFilter.js